import { apiRecordXinfaPlayData, apiRecordPlayData } from '@/models/study2'

export async function recordXinfaPlayData(id, offset) {
    try {
      await apiRecordXinfaPlayData({
        bizId: id,
        offset,
        command: 'PAUSE',
      })
    } catch (err) {
      console.log('记录播放数据失败：', err)
    }
}

/**
 * 记录音视频和文本学习
 * @param {object} data 数据
 * @param {number} data.id 课程id
 * @param {number} data.bizType 业务类型 1-心法集 2-课程
 * @param {number} data.type 课程类型 1-音频和视频 2-文本
 * @param {number} data.offset 播放时间
 * @param {number} elementType 元素类型
 */
export async function recordStudyPlayData(data, elementType) {
    const isFullStudy = isFullStudyElement(elementType)
    try {
        if (isFullStudy) {
          await apiRecordPlayData({
            bizId: data.id,
            bizType: '整听整看',
            type: data.type,
            offset: data.offset,
            command: 'PAUSE',
          })
        } else {
            await apiRecordPlayData({
              bizId: data.id,
              bizType: data.bizType,
              type: data.type,
              offset: data.offset,
              command: 'PAUSE',
            })
        }
    } catch (err) {
      console.log('记录播放数据失败：', err)
    }
}

// 是否是整听整看元素
function isFullStudyElement(type) {
    return type === 'PREVIEW_VIDEO' || type === 'PREVIEW_AUDIO' || type === 'STUDY_MESSAGE'
}
